import { Color3, Effect, Mesh, MeshBuilder, type Scene, ShaderMaterial, Vector3 } from "@babylonjs/core";
import { SKY_STOPS, sunDirection } from "./atmosphere";

Effect.ShadersStore["nomenSkyVertexShader"] = `
precision highp float;
attribute vec3 position;
uniform mat4 worldViewProjection;
varying vec3 vDir;
void main(void) { vDir = position; gl_Position = worldViewProjection * vec4(position, 1.0); }`;

Effect.ShadersStore["nomenSkyFragmentShader"] = `
precision highp float;
varying vec3 vDir;
uniform vec3 c0; uniform vec3 c1; uniform vec3 c2;
uniform float e1;
uniform vec3 sunDir; uniform vec3 sunColor;
void main(void) {
  vec3 d = normalize(vDir);
  float e = degrees(asin(clamp(d.y, -1.0, 1.0)));
  vec3 col = e <= 0.0 ? c0 : (e <= e1 ? mix(c0, c1, e / e1) : mix(c1, c2, (e - e1) / (90.0 - e1)));
  float a = degrees(acos(clamp(dot(d, -sunDir), -1.0, 1.0)));
  col += sunColor * smoothstep(6.0, 0.0, a) * 0.6;
  gl_FragColor = vec4(col, 1.0);
}`;

/** Gradient sky dome that ignores fog and follows the camera (spec 2d §3). */
export function createSky(scene: Scene, sunHex: string): Mesh {
  const dome = MeshBuilder.CreateSphere("sky", { diameter: 800, segments: 24, sideOrientation: Mesh.BACKSIDE }, scene);
  const m = new ShaderMaterial("sky", scene, "nomenSky", {
    attributes: ["position"],
    uniforms: ["worldViewProjection", "c0", "c1", "c2", "e1", "sunDir", "sunColor"],
  });
  const c = SKY_STOPS.map((s) => Color3.FromHexString(s.color));
  m.setColor3("c0", c[0]!);
  m.setColor3("c1", c[1]!);
  m.setColor3("c2", c[2]!);
  m.setFloat("e1", SKY_STOPS[1]!.elevationDeg);
  m.setVector3("sunDir", new Vector3(...sunDirection()));
  m.setColor3("sunColor", Color3.FromHexString(sunHex));
  m.backFaceCulling = false;
  dome.material = m;
  dome.infiniteDistance = true;
  dome.applyFog = false;
  dome.isPickable = false;
  dome.renderingGroupId = 0;
  return dome;
}
